import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StatusOfferState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: StatusOfferState = {
  data: [],
  isLoading: false,
  error: null,
};

const statusOfferSlice = createSlice({
  name: 'statusOffer',
  initialState,
  reducers: {
    setOfferStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setStatusOfferLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatusOfferError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setOfferStatuses, setStatusOfferLoading, setStatusOfferError } = statusOfferSlice.actions;

export default statusOfferSlice.reducer;
